export default "__VITE_ASSET__bOTlsD_7__"